/**
 * Marketing tracking parameters configuration
 *
 * Centralizes all marketing tracking parameters that are:
 * - Captured from URL query parameters
 * - Stored in session storage
 * - Persisted to database as metadata
 * - Sent to Segment analytics
 */

/**
 * Standard UTM parameters for campaign tracking
 */
export const UTM_PARAMETERS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const

/**
 * Platform-specific click IDs for conversion tracking
 */
export const CLICK_ID_PARAMETERS = [
  // Google Ads
  'gclid',
  'gbraid',
  'wbraid',

  // Microsoft Ads
  'msclkid',

  // Meta (Facebook)
  'fbclid',

  // TikTok
  'ttclid',

  // LinkedIn
  'li_fat_id',

  // Reddit
  'rdt_cid',

  // Quora
  'qclid',

  // Outbrain
  'ob_click_id',
  'obcid',

  // Taboola
  'tbclid',
  'tclid',

  // Yahoo DSP
  'yclid',

  // MediaGo
  'mgclid',

  // Dianomi
  'utm_click_id',

  // RevContent
  'revcontent_click_id',
  'rcid',

  // NewsBreak
  'nb_cid',

  // LiveIntent
  'li_did',
  'li_eid',

  // Jeeng
  'jeeng_cid',
  'jeeng_id',

  // Twitter/X
  'twclid',

  // Pinterest
  'epik',

  // Sharethrough
  'stclid',

  // MNTN
  'mntn_cid',
  'shcid',
] as const

/**
 * All tracking parameters combined for easy iteration
 */
export const ALL_TRACKING_PARAMETERS = [...UTM_PARAMETERS, ...CLICK_ID_PARAMETERS] as const
